/* variant.js · lógica pura de seleção de variante e quantidade (browser + Node). */
(function (root, factory) {
  var api = factory();
  root.SXE = root.SXE || {};
  root.SXE.variant = api;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
})(typeof self !== 'undefined' ? self : this, function () {
  // Uma variante é compatível com uma seleção (possivelmente parcial) quando, para
  // cada índice de opção, o valor selecionado é null (não escolhido) ou igual ao da variante.
  function matchesSelection(variant, values) {
    if (!variant || !variant.options) return false;
    return values.every(function (val, i) { return val == null || variant.options[i] === val; });
  }

  // Existe alguma variante DISPONÍVEL compatível com esta seleção (parcial)?
  // Usado para marcar como esgotada cada opção que não leva a nenhuma variante comprável.
  function isAvailable(variants, values) {
    if (!variants) return false;
    return variants.some(function (v) { return v.available && matchesSelection(v, values); });
  }

  // A variante que corresponde a uma seleção COMPLETA (todos os valores definidos).
  // Retorna null enquanto a seleção estiver incompleta ou sem correspondência.
  function findVariant(variants, values) {
    if (!variants) return null;
    return variants.filter(function (v) {
      return v.options && values.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  }

  // Teto de quantidade (UX apenas — a validacao final e do checkout da Shopify).
  // So ha teto quando o estoque e rastreado pela Shopify E a politica e 'deny' (nao vende
  // esgotado). 'continue' ou nao-rastreado => null (sem teto), comportamento de hoje.
  // stock = { management, policy, qty } emitido por variante no template.
  function stockCeiling(stock) {
    if (!stock) return null;
    if (stock.management === 'shopify' && stock.policy === 'deny') {
      var q = parseInt(stock.qty, 10);
      return isNaN(q) ? null : q;
    }
    return null;
  }

  // Normaliza um teto: inteiro >= 1, ou null quando nao ha teto aplicavel.
  function normCap(max) {
    var c = parseInt(max, 10);
    return (isNaN(c) || c < 1) ? null : c;
  }

  // Quantidade nunca abaixo de 1; entrada inválida (vazia/NaN) é normalizada para 1.
  function decrementQty(raw) { var n = parseInt(raw, 10) || 1; return n > 1 ? n - 1 : n; }
  // Soma 1, respeitando o teto quando houver. Sem teto (ou teto invalido) => ilimitado, como antes.
  function incrementQty(raw, max) {
    var n = (parseInt(raw, 10) || 1) + 1;
    var cap = normCap(max);
    return (cap !== null && n > cap) ? cap : n;
  }
  // Prende um valor ao intervalo [1, teto] (valor inicial / troca de variante).
  function clampQty(raw, max) {
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1) n = 1;
    var cap = normCap(max);
    return (cap !== null && n > cap) ? cap : n;
  }

  return {
    matchesSelection: matchesSelection,
    isAvailable: isAvailable,
    findVariant: findVariant,
    stockCeiling: stockCeiling,
    decrementQty: decrementQty,
    incrementQty: incrementQty,
    clampQty: clampQty
  };
});
